import { STORAGE_KEYS } from '~/constants/storageKeys';

interface LastVideoState {
	propertyId: string;
	index: number;
	timestamp: number;
}

const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function useLastVideoState() {
	function save(propertyId: string, index: number): void {
		if (!import.meta.client) return;

		try {
			const state: LastVideoState = {
				propertyId,
				index,
				timestamp: Date.now()
			};
			localStorage.setItem(
				STORAGE_KEYS.LAST_VIDEO_STATE,
				JSON.stringify(state)
			);
		} catch {
			// localStorage unavailable
		}
	}

	function get(): LastVideoState | null {
		if (!import.meta.client) return null;

		try {
			const stored = localStorage.getItem(STORAGE_KEYS.LAST_VIDEO_STATE);
			if (!stored) return null;

			const state: LastVideoState = JSON.parse(stored);

			if (Date.now() - state.timestamp > MAX_AGE_MS) {
				localStorage.removeItem(STORAGE_KEYS.LAST_VIDEO_STATE);
				return null;
			}

			return state;
		} catch {
			return null;
		}
	}

	return { save, get };
}
